export class AwsRestoreServerNetworkParams {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "securityGroupIds",
            "baseName": "securityGroupIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsRestoreServerNetworkParams.attributeTypeMap;
    }
    constructor() {
    }
}
